import { Breadcrumb } from '@/components/general/BreadCrumb';
import SectionHead from '@/components/general/SectionHead';
import React from 'react';
import styles from './styles.module.css';
import { InfoCardItem } from '@/commonTypes';
import InfoCard from '@/components/pages/profile/ProfileContent/AccountHero/InfoCard';
import { useTranslations } from 'next-intl';

export default function BrandsHero({
  brandCount = 0,
  modelCount = 0,
  blogCount = 0,
}: {
  brandCount?: number;
  modelCount?: number;
  blogCount?: number;
}) {
  const tCommon = useTranslations('common');
  const stats: InfoCardItem[] = [
    {
      id: 1,
      title: 'تعداد برند',
      text: `${brandCount}`,
      href: '#',
      unit: '',
      valueClass: 'box1',
    },
    {
      id: 2,
      title: 'مدل خودرو',
      text: `${modelCount}`,
      href: '#',
      unit: '',
      valueClass: 'box3',
    },
    {
      id: 3,
      title: 'مقاله و راهنما',
      text: `${blogCount}`,
      href: '/blogs',
      unit: '',
      valueClass: 'box2',
    },
  ];
  return (
    <>
      <Breadcrumb items={[{ label: tCommon('homeTitle'), to: '/' }, { label: tCommon('seo.brands.title') }]} />
      <div className={`hero`}>
        <SectionHead
          title={'همهٔ برندهای خودرو، یک‌جا'}
          text={
            'اطلاعات کامل برندهای داخلی و وارداتی؛ مدل‌ها، مشخصات و قیمت روز را در پروفایل هر برند ببین.'
          }
          tag={'دایرکتوری برندها'}
          headingTag="h1"
          type="otherPages"
          // titleClass={`${styles.titleClass}`}
        />
        <div className={`statsList`}>
          {stats?.map((item?: InfoCardItem, index?: number) => (
            <InfoCard item={item} key={index} statValueClass={item?.valueClass} />
          ))}
        </div>
      </div>
    </>
  );
}
